"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var ProjectsActions = require("@caddigital/sok-reducers/lib/actions/projects");
var ProjectSelector_1 = require("components/ProjectSelector");
var OrderListActions = require("@caddigital/sok-reducers/lib/actions/order/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var constants_1 = require("utils/constants");
var ClearSearchCross = function (_a) {
    var searchString = _a.searchString, onClear = _a.onClear;
    if (!searchString)
        return null;
    return (React.createElement("span", { className: "file-list-search-box-right" },
        React.createElement(Icon_1.Icon, { onClick: onClear, className: "fa-times" })));
};
exports.SearchBar = React.memo(function (props) {
    var _a = React.useState(null), tempValue = _a[0], setTempValue = _a[1];
    var searchString = (0, react_redux_1.useSelector)(function (state) { return state.order.list.searchString; });
    var dispatch = (0, react_redux_1.useDispatch)();
    var timeoutRef = React.useRef(null);
    React.useEffect(function () {
        dispatch(ProjectsActions.fetchProjects({
            limit: 6,
            order: 'DESC',
            orderBy: 'visitedAt'
        }));
    }, [dispatch, props.currentProject]);
    var handleSearchChange = function (value) {
        setTempValue(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            dispatch(OrderListActions.setSearchString(value));
            setTempValue(null);
        }, constants_1.SEARCH_TIMEOUT);
    };
    return (React.createElement(sok_ui_1.Grid.Row, { className: "sok-search-bar-content" },
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
            React.createElement(ProjectSelector_1.ProjectSelector, { navigateToProject: props.navigateToProject }),
            React.createElement("div", { className: "search-area" },
                React.createElement(sok_ui_1.TextInput, { value: tempValue === null ? searchString : tempValue, placeholder: (0, translation_1.getLocalization)('userfront/orders/search'), onChange: function (e) {
                        return handleSearchChange(e.target.value);
                    }, icon: React.createElement(Icon_1.Icon, { key: "icon", className: "fa-search" }), iconRight: React.createElement(ClearSearchCross, { searchString: searchString, onClear: function () { return dispatch(OrderListActions.setSearchString('')); } }) })))));
});
